document.addEventListener('DOMContentLoaded', function() {
  const thumbnails = document.querySelectorAll('.pdp-video-badges .video-thumbnail');
  const popup = document.querySelector('.pdp-video-badges #video-popup');
  const popupVideo = document.querySelector('.pdp-video-badges #popup-video');
  const videoSource = document.querySelector('.pdp-video-badges #video-source');
  const closeBtn = document.querySelector('.pdp-video-badges .popup .close');

  // Iniciar los videos en las miniaturas
  const thumbnailVideos = document.querySelectorAll('.pdp-video-badges .thumbnail-video');
  thumbnailVideos.forEach(video => {
    video.play();
  });

  thumbnails.forEach(thumbnail => {
    thumbnail.addEventListener('click', function(event) {
      const videoUrl = this.getAttribute('data-video');
      event.stopPropagation(); // Detiene la propagación del evento de clic
      videoSource.src = videoUrl;
      popupVideo.load();
      popup.style.display = 'block';
    });
  });

  // Función para cerrar el popup y pausar el video
  function closePopup() {
    popup.style.display = 'none';
    popupVideo.pause(); // Pausa el video cuando se cierra el popup
  }

  // Cerrar el popup al hacer clic en la "equis"
  closeBtn.addEventListener('click', closePopup);

  // Cerrar el popup al hacer clic en cualquier parte fuera del modal
  window.addEventListener('click', function(event) {
    if (event.target !== popup && !popup.contains(event.target)) {
      closePopup();
    }
  });
});
